module.exports = __webpack_public_path__ + "img/symbol_8.af873d5c.png";